import axios from 'axios'

const API_URL = process.env.REACT_APP_PRODUCTION_API_ENDPOINT?.replace('/graphql', '')

export const instance = axios.create({
  baseURL: `${API_URL}/api/v1`,
  timeout: 1000,
  headers: { 'X-Custom-Header': 'foobar' },
})

export default instance
